import { override } from 'flarum/extend';
import Application from 'flarum/common/Application';

export default function () {
	override(Application.prototype, 'preloadedApiDocument', function (original) {
		// Execute the original only if the keys "data" and "included" are present
		if (this.data.apiDocument && this.data.apiDocument.data && this.data.apiDocument.included) {
			original();
		}

		// This avoids errors when we supercharged the API document for the home page

		// For debugging:
		// if (this.data.apiDocument) {
		// 	console.log('preloadedApiDocument not executed');
		// }
	});

	// The API document of the home page has a custom structure, so we can't use
	// the default `preloadedApiDocument` method. This new method is handling the
	// data structure of the home page API document and can be used throughout the
	// app to access preloaded data.
	Application.prototype.preloadedHomeApiDocument = function (key) {
		if (this.data?.apiDocument && this.data.apiDocument[key]) {
			const payload = this.data.apiDocument[key];
			const results = this.store.pushPayload(payload);

			delete this.data.apiDocument[key];

			return results;
		}

		return null;
	};
}
